export const Roles = {
    Company: "company",
    Location: "location",
    SUPERADMIN: "superadmin",
} as const;

export const Types = {
    User: "user",
    ADMIN: "admin",
} as const;

export const RoleOptions :any= [
  { value: "company", label: "Company" },
  { value: "location", label: "Location" },
];

export const RoleTypeOptions :any= [
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
];
export const UserPermissions :any= [
  "Dashboard",
  "Sub Accounts",
  "Team",
];
